<template>
    <b-container class="mt-3">
        <b-form @submit="onSubmit">
            <userForm :user="user" :options="options" :vendedorsap="vendedorsap"></userForm>
            <b-button  :disabled="errors.any()" type="submit" variant="primary" class="mb-5">Guardar</b-button>
        </b-form>    
    </b-container>
</template>

<script>
    import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    import userForm from '@/components/admin/userFormUpdate'
    import {mapActions,mapState} from 'vuex'
    import _ from 'lodash'
    export default {
        components:{
            userForm
        },     
        mixins : [validateMixin],
        data() {
            return {
                reset:false,
                options: [],
                vendedorsap:[]
              
            }
        },        
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('admin',['isOk','user']),
            ...mapState('vendedor',['oslp']),
            ...mapState('roles',['roles'])
        },
        
        methods:{
            ...mapActions({
                __update: 'admin/update',
                _oslp: 'vendedor/getOslp',
                _fetchRoles: 'roles/fetchRoles',
                
            }),
            init(){
                let that = this
                this._oslp().then(() => { 
                    _.forEach(this.oslp, function(value,key){
                        let payload = {
                                     value: value.SlpCode,
                                     text:  value.SlpName
                                } 
                        that.vendedorsap.push(payload)  
                    })//forEach
                }) //then
                this._fetchRoles().then(() => {
                    _.forEach(this.roles, function(value,key){
                        let payload = {
                            value: value.id,
                            text: value.description
                        }
                        that.options.push(payload)
                    })//forEach
                })//then

            },
            /**
             *  metodo que limpia campos y errores.
             */
            onReset(){
                this.clearForm()
                this.clearErrors()
            },
            /**
             * metodo que limpia los campos
             */
            clearForm(){
                Object.assign(this.$data, this.$options.data.apply(this))
            },
            /*
             * metodo que limpia los errores 
             */
            clearErrors(){
                this.reset = true
                this.$validator.reset()
            },
            async onSubmit(evt){
                evt.preventDefault()
                this.reset = false
                const validate = await this.$validator.validateAll()
                if(!validate) {
                    return false
                } 
                this.__update(this.user).then(() => {
                    if(this.isOk){
		    			    this.$toasted.show('El formulario se guardo correctamente', { 
	 	    						theme: "bubble", 
	 	    						position: "top-right", 
	 	    						duration : 3000
                            })
                        this.onReset()
                        this.$router.push('usuarios')
                    }else{
                        this.$toasted.show('Error al guardar el formulario', { 
                  				duration : 3000
                          })
                    }
                })
            },
            

        }

        
        
    }
</script>

<style lang="scss" scoped>

</style>